<div *ngIf="lineChartData.labels.length">
    <canvas class="w-100" baseChart [data]="lineChartData" [options]="lineChartOptions"
            (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)">
    </canvas>
</div>

<p *ngIf="!lineChartData.labels.length">
    <ng-container *ngFor="let param of elementoRUP.params">
        No se ha registrado ningún valor de {{ param.label }} para el paciente.
    </ng-container>
</p>